import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
	root: {},

	cell: {
		width: '250px',
	},
	cellStyle: {
		width: '9.25rem',
	},
}));
